'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Switch as SwitchPrimitive } from 'radix-ui';
import { tv } from 'tailwind-variants';
import { Label } from '../typography/Label';
import type { LabelVariants } from '../typography/Label';
const _switch = tv({
  slots: {
    root: `
      peer
      data-[state=checked]:bg-primary
      data-[state=unchecked]:bg-input
      focus-visible:ring-content-primary
      dark:data-[state=unchecked]:bg-input/80
      disabled:data-[state=unchecked]:bg-background-quaternary!
      disabled:data-[state=checked]:bg-background-quinary!
      disabled:cursor-not-allowed
      inline-flex
      h-4
      w-8
      shrink-0
      items-center
      rounded-full
      border
      border-transparent
      shadow-xs
      transition-transform
      outline-none
      focus-visible:ring-1
      focus-visible:ring-offset-1
      cursor-pointer
    `,
    thumb: `
      bg-background
      dark:data-[state=unchecked]:bg-foreground
      dark:data-[state=checked]:bg-primary-foreground
      pointer-events-none
      block
      size-3
      rounded-full
      ring-0
      transition-transform
      data-[state=checked]:translate-x-[calc(100%+0.25rem)]
      data-[state=unchecked]:translate-x-0.5
      `
  },
  variants: {
    disabled: {
      true: {
        thumb: `bg-background-disabled!`
      }
    }
  }
});
type SwitchProps = {
  label?: string;
  labelSize?: LabelVariants['size'];
  labelPosition?: 'left' | 'right';
} & React.ComponentProps<typeof SwitchPrimitive.Root>;
function Switch(t0) {
  const $ = _c(25);
  let T0;
  let T1;
  let labelPosition;
  let switchLabel;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t0) {
    const {
      className,
      label,
      labelSize: t7,
      labelPosition: t8,
      ...props
    } = t0;
    const labelSize = t7 === undefined ? "md" : t7;
    labelPosition = t8 === undefined ? "right" : t8;
    const {
      root,
      thumb
    } = _switch({
      className,
      disabled: props.disabled
    });
    switchLabel = label ? <Label className="cursor-pointer" disabled={props.disabled} htmlFor={props.id} size={labelSize}>{label}</Label> : null;
    t5 = "flex items-center space-x-2 mt-0.5";
    t6 = labelPosition === "left" && switchLabel;
    T1 = SwitchPrimitive.Root;
    t2 = root({
      className
    });
    t3 = "switch";
    t4 = props;
    T0 = SwitchPrimitive.Thumb;
    t1 = thumb();
    $[0] = t0;
    $[1] = T0;
    $[2] = T1;
    $[3] = labelPosition;
    $[4] = switchLabel;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    T0 = $[1];
    T1 = $[2];
    labelPosition = $[3];
    switchLabel = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== T0 || $[12] !== t1) {
    t7 = <T0 className={t1} data-slot="switch-thumb" />;
    $[11] = T0;
    $[12] = t1;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== T1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t7) {
    t8 = <T1 className={t2} data-slot={t3} {...t4}>{t7}</T1>;
    $[14] = T1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = labelPosition === "right" && switchLabel;
  let t10;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className={t5}>{t6}{t8}{t9}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
export { Switch };